import { createAction, props } from '@ngrx/store';
import { EnrolleeRecord } from '../../interfaces/enrollee.interface';

export const loadCurrentEnrollee = createAction(
  '[Policy Dashboard] Load Current Enrollee'
);

export const loadCurrentEnrolleeSuccess = createAction(
  '[Enrollee API] Load Current Enrollee Success',
  props<{
    enrollmentId: number;
    enrollee: EnrolleeRecord;
  }>()
);

export const loadCurrentEnrolleeFailure = createAction(
  '[Enrollee API] Load Current Enrollee Failure',
  props<{
    error: string;
  }>()
);

export const clearCurrentEnrollee = createAction(
  '[Enrollee] Clear Current Enrollee'
);